module.exports = __webpack_public_path__ + "img/Nosotros.1bb4991a.png";